import Api from '../../../utils/api.js'
export const SET_PRODUCTS = 'SET_PRODUCTS'

export function setProducts (products) {
  const result = {
    type: SET_PRODUCTS,
    payload: products
  }
  return result
}

export function getProducts () {
  return dispatch => {
    return Api.getAvailableVariants().then(payload => {
      dispatch(setProducts(payload))
    })
  }
}
